import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ClipBoardService } from '../../../services/clipboard.service'
import { ServerService } from '../../../services/server.service'
@Component({
    selector: 'client-lead-profile-task-create-modal',
    templateUrl: './client-lead-profile-task-create-modal.component.html',
    styleUrls: ['./client-lead-profile-task-create-modal.component.scss']
})
export class ClientLeadProfileTaskCreateModalComponent implements OnInit {
    public currentUser = JSON.parse(localStorage.getItem("userInfo"));
    authToken = localStorage.getItem("token")
    authInfo: any = JSON.parse(localStorage.getItem("authInfo"))
    projectInfo: any = JSON.parse(localStorage.getItem("projectInfo"))
    leadInfo: any = JSON.parse(localStorage.getItem("leadInfo"))
    // sessionStorage.setItem('lead_status_changed','false');
    
    lead_status_changed = sessionStorage.getItem('lead_status_changed');
    is_disabled:any = false;
    action = "";
    addTaskToggleButton = false;
    tasks: any[] = []
    public min = new Date()
    public max: Date;
    subjectDisabled:any;
    autoReminderNotification: boolean = true
    saveStatus: boolean = false
    createTaskForm: FormGroup;
    constructor(
        private serverService: ServerService,
        private clipBoardService: ClipBoardService,
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<ClientLeadProfileTaskCreateModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {
            // console.log(this.lead_status_changed)
           
       
    }

    ngOnInit() {
        
        if(this.lead_status_changed == 'true'){
            
            this.subjectDisabled = true
        }
        else if(this.lead_status_changed == 'false'){
            this.subjectDisabled = false;
        }
        if(this.lead_status_changed == 'true'){
            // console.log("lead")
            this.is_disabled = "true";
            this.createTaskForm = this.fb.group({
                "task_category": ["Call", Validators.required],//"Phone",
                "subject": ['Reminder - '+ this.leadInfo.project.name +'-' + this.leadInfo.lead_status, Validators.required],//"please call on phone for specific lead",
                "priority": ["1", Validators.required],//"High",
                "description": ["Lead Id:"+ this.leadInfo.id + "\n" + "Name : "+ this.leadInfo.name +  "\n" + "Email:" 
                + this.leadInfo.email  + "\n" + "Phone:"+ this.leadInfo.phone],//"hi every one please send email templates for given lead id Thank you",
                "due_date": [new Date()],//"2019-02-10 15:44:37",
                "auto_remainder": [false],
                "custom_remainder": [new Date()],//"2019-02-09 15:44:37",
            });
        }
        else if(this.lead_status_changed == 'false'){
            // console.log("task")
            this.createTaskForm = this.fb.group({
                "task_category": ["", Validators.required],//"Phone",
                "subject": ["", Validators.required],//"please call on phone for specific lead",
                "priority": ["", Validators.required],//"High",
                "description": [""],//"hi every one please send email templates for given lead id Thank you",
                "due_date": [new Date()],//"2019-02-10 15:44:37",
                "auto_remainder": [false],
                "custom_remainder": [new Date()],//"2019-02-09 15:44:37",
            });
        }
        // console.log(this.leadInfo)
    }
    addTaskToggle(){
        this.addTaskToggleButton = !this.addTaskToggleButton;
        // console.log(this.add)
    }
    addTask() {
        this.saveStatus = true;
        let body = {}
        if(this.lead_status_changed == 'true'){
            body = {
                "task_category": this.createTaskForm.value.task_category,
                "subject": this.createTaskForm.value.subject,
                "priority": this.createTaskForm.value.priority,
                "description": this.createTaskForm.value.description,
                "due_date": this.createTaskForm.value.due_date.toJSON(),//"2019-02-10 15:44:37",
                "auto_reminder": this.autoReminderNotification,
                "custom_reminder": this.createTaskForm.value.custom_remainder.toJSON(),//"2019-02-09 15:44:37",
                "lead_id": this.leadInfo.id
            }
        }
        else{
            body = {
                "task_category": this.createTaskForm.value.task_category,
                "subject": this.createTaskForm.value.subject,
                "priority": this.createTaskForm.value.priority,
                "description": this.createTaskForm.value.description,
                "due_date": this.createTaskForm.value.due_date.toJSON(),//"2019-02-10 15:44:37",
                "auto_reminder": this.autoReminderNotification,
                "custom_reminder": this.createTaskForm.value.custom_remainder.toJSON(),//"2019-02-09 15:44:37",
                "lead_id": this.data.id
            }
        }
       if(this.lead_status_changed == 'true' && this.addTaskToggleButton ){
        this.serverService.createLeadTask(body, this.authToken).subscribe(
            data => {
                this.dialogRef.close("Task Created Successfully")
                this.clipBoardService.showMessgeInText("Task Created Successfully", "success-snackbar")
                this.saveStatus = false;

            },
            err => {
                this.clipBoardService.checkServerError(err, this.authToken)
                this.saveStatus = false;
            }
        )
       }
       else if(this.lead_status_changed == 'false'){
        this.serverService.createLeadTask(body, this.authToken).subscribe(
            data => {
                this.dialogRef.close("Task Created Successfully")
                this.clipBoardService.showMessgeInText("Task Created Successfully", "success-snackbar")
                this.saveStatus = false;

            },
            err => {
                this.clipBoardService.checkServerError(err, this.authToken)
                this.saveStatus = false;
            }
        )
       }
       else{
        this.dialogRef.close("Lead Status Updated Successfully");
       }
    }

    close() {
        this.dialogRef.close();
    }

    checkAutoReminder() {
        this.autoReminderNotification = !this.autoReminderNotification
    }
}

